'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ContentCardHeader = require('./ContentCardHeader');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ContentCardHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }